export default __webpack_public_path__ + "static/media/pod_details.f2cb7df7.png";